import { useState } from 'react';
import { s } from './Result.styles';
import PatternService from '../../../../service/Pattern';
import { usePatternContext } from '../../../../context/PatternContext';
import { useNavigate } from 'react-router-dom';

interface Props {
  setShowSaveModal: (value: boolean) => void;
  getList?: (tab: string) => void;
  page?: string;
  isSaveDone: boolean;
  setIsSaveDone: (value: boolean) => void;
}
const SaveModal = ({
  setShowSaveModal,
  getList,
  page,
  isSaveDone,
  setIsSaveDone,
}: Props) => {
  const [patternName, setPatternName] = useState('');
  const [loading, setLoading] = useState(false);
  const { pIdx } = usePatternContext();
  const navigate = useNavigate();

  const savePattern = async () => {
    try {
      const data = {
        title: patternName,
      };
      setLoading(true);
      const res = await PatternService.saveMyPattern(pIdx, data);
      if (res.status === 'success') {
        setLoading(false);
        setIsSaveDone(true);
        getList && getList('A');
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  return (
    <s.SaveModal
      style={{
        alignItems: isSaveDone ? 'center' : 'flex-end',
        padding: isSaveDone ? '16px' : '0',
      }}
    >
      {!isSaveDone && (
        <s.SaveModalInner
          style={{
            width: '100%',
            borderRadius: '20px 20px 0px 0px',
          }}
        >
          <s.ModalTitle>
            <span
              style={{
                width: '100%',
                textAlign: 'center',
              }}
            >
              내 알고리즘 저장
            </span>
            <img
              src="/assets/images/close/close-black-14.svg"
              alt=""
              onClick={() => {
                setShowSaveModal(false);
              }}
            />
          </s.ModalTitle>
          <s.InputBox>
            <div>내 알고리즘 명</div>
            <s.PatternInput
              type="text"
              placeholder="예) 임대수익용 아파트 알고리즘"
              value={patternName}
              onChange={(e) => setPatternName(e.target.value)}
            />
            <s.GuideText>
              <img src="/assets/images/icon/info-gray.svg" alt="" />{' '}
              <span>검색조건 이름 미입력 시 자동으로 저장됩니다.</span>
            </s.GuideText>
          </s.InputBox>
          <s.ModalButtonBox>
            <s.CancelButton
              onClick={() => {
                setShowSaveModal(false);
              }}
            >
              취소
            </s.CancelButton>
            <s.AnalyzeButton
              style={{ width: '286px', height: '47px' }}
              onClick={() => {
                savePattern();
              }}
              disabled={loading}
            >
              알고리즘 저장
            </s.AnalyzeButton>
          </s.ModalButtonBox>
        </s.SaveModalInner>
      )}

      {isSaveDone && (
        <s.SaveModalInner style={{ width: '360px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <s.ModalTitle>
              <span> 알고리즘 저장 완료</span>
            </s.ModalTitle>
            <s.GuideText>
              <span>나만의 알고리즘이 저장되었습니다.</span>
            </s.GuideText>
          </div>
          <s.ModalButtonBox>
            <s.CancelButton
              style={{
                flex: 1,
                background: '#fff',
                border: '1px solid #008AFF',
                color: '#008AFF',
              }}
              onClick={() => {
                setShowSaveModal(false);
              }}
            >
              닫기
            </s.CancelButton>
            {page !== 'patternList' && (
              <s.AnalyzeButton
                style={{ flex: 1 }}
                onClick={() => {
                  setShowSaveModal(false);
                  navigate('/myAlgorithmList');
                }}
              >
                내 알고리즘 관리
              </s.AnalyzeButton>
            )}
          </s.ModalButtonBox>
        </s.SaveModalInner>
      )}
    </s.SaveModal>
  );
};

export default SaveModal;
